import { motion } from 'framer-motion'
import { ArrowLeft } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Button } from '@/components/ui/Button'
import { FinanceRequestDetailContent } from '@/components/Financeiro/FinanceRequestDetailContent'
import { FinanceRequestDetailHeader } from '@/components/Financeiro/FinanceRequestDetailHeader'
import { useFinanceRequestDetailPage } from '@/hooks/useFinanceRequestDetailPage'

export default function FinanceRequestDetailPage() {
  const {
    detail,
    loading,
    error,
    canManageQueue,
    canGenerateG5Invite,
    canViewFinancialValues,
    canViewClosedScope,
    assignees,
    reload,
    goBack,
    updateStatus,
    assignRequest,
    addComment,
  } = useFinanceRequestDetailPage()

  return (
    <DashboardLayout
      title={detail?.typeLabel ?? 'Solicitação financeira'}
      actions={
        <Button variant='secondary' size='sm' type='button' onClick={goBack}>
          <ArrowLeft size={14} />
          Voltar aos chamados
        </Button>
      }
    >
      {error && (
        <div className='mb-4 rounded-lg border border-danger/30 bg-danger/5 px-4 py-3 text-sm text-danger'>
          {error}
        </div>
      )}

      {loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : detail ? (
        <div className='space-y-6'>
          <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
            <FinanceRequestDetailHeader detail={detail} />
          </motion.div>

          <FinanceRequestDetailContent
            detail={detail}
            canManageQueue={canManageQueue}
            canGenerateG5Invite={canGenerateG5Invite}
            canViewFinancialValues={canViewFinancialValues}
            canViewClosedScope={canViewClosedScope}
            assignees={assignees}
            onUpdateStatus={updateStatus}
            onAssign={assignRequest}
            onAddComment={addComment}
            onReload={() => void reload()}
          />
        </div>
      ) : null}
    </DashboardLayout>
  )
}
